import { ArticleResolution, KnownIssueResolutions } from '@wix/answers-api';
import { Box, SectionHelper, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys } from '../../../../types';
import { HelpCenterArticle } from '../../types';

export interface KnownIssueStatusProps {
  article: HelpCenterArticle;
}

const localeKeyByResolution: Record<KnownIssueResolutions, TLocalesKeys> = {
  // Known issue resolutions
  [ArticleResolution.INVESTIGATING]:
    'article_header_known_issue_resolution_investigating',
  [ArticleResolution.WORKING_ON_IT]:
    'article_header_known_issue_resolution_working_on_it',
  [ArticleResolution.RESOLVED]:
    'article_header_known_issue_resolution_resolved',
  [ArticleResolution.THIRD_PARTY_BUG]:
    'article_header_known_issue_resolution_third_party_bug',
};

const appearenceByResolution: Record<
  KnownIssueResolutions,
  'danger' | 'warning' | 'success'
> = {
  [ArticleResolution.INVESTIGATING]: 'danger',
  [ArticleResolution.WORKING_ON_IT]: 'warning',
  [ArticleResolution.RESOLVED]: 'success',
  [ArticleResolution.THIRD_PARTY_BUG]: 'danger',
};

export const KnownIssueStatus: FC<KnownIssueStatusProps> = ({ article }) => {
  const { t } = useTranslation();

  if (!article.resolution || !localeKeyByResolution[article.resolution]) {
    return null;
  }

  return (
    <Box direction="vertical">
      <SectionHelper
        size="small"
        appearance={appearenceByResolution[article.resolution]}
      >
        <Text weight="bold" size="small">
          {t<TLocalesKeys>('article_header_type_known_issue')}
        </Text>
        <Text size="small">
          {' '}
          | {t<TLocalesKeys>(localeKeyByResolution[article.resolution])}
        </Text>
      </SectionHelper>
    </Box>
  );
};
